export default {

  states () {
    return [
      {
        name: 'open',
        friendlyName: 'Open to Comments',
        description: 'Anyone with the URL can view and add comments. Only collaborators can edit.',
        descriptionGroup: 'Anyone can view and add comments. Only group members and collaborators can edit.',
        color: 'success',
        icon: 'comment'
      },
      {
        name: 'closed',
        shortName: 'public',
        friendlyName: 'Public Read Only',
        description: 'Anyone with the URL can view. Only collaborators can edit.',
        descriptionGroup: 'Anyone can view. Only group members and collaborators can edit.',
        color: 'info',
        icon: 'unlock'
      },
      {
        name: 'private',
        friendlyName: 'Private Space',
        description: 'Only collaborators can view and edit.',
        descriptionGroup: 'Only group members and collaborators can view and edit.',
        color: 'danger',
        icon: 'lock'
      }
    ]
  }

}
